import React from 'react';
import { useLocation } from '@reach/router';
import { AppPath, SubscriptionTypes } from 'appConstants';
import { Package, Subjects } from 'pages/newSubscription/models';

type Props = {
  duration: SubscriptionTypes.STANDARD | SubscriptionTypes.INVESTEMENT;
  toggleSubscriptionDuration: (p: Package) => void;
  subjectInfo: Subjects;
  checkPackageAvailable: boolean;
};

export const SubscriptionDurationOptions: React.FC<Props> = ({
  duration,
  toggleSubscriptionDuration,
  subjectInfo,
  checkPackageAvailable
}) => {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <div className="SubscriptionDurationOptions">
      {subjectInfo.subscriptions.map((s: Package, i: number) => (
        <div
          key={i}
          className={`SDOpt 
            ${duration === s.type && (checkPackageAvailable || AppPath.SUBSCRIBE === pathname) ? `Selected` : `Unselected`} 
            ${s.isAvailableForSchool || AppPath.SUBSCRIBE === pathname ? `` : `Block`}
          `}
          onClick={() =>
            s.isAvailableForSchool || AppPath.SUBSCRIBE === pathname ? toggleSubscriptionDuration(s)
              : null
          }          
        >
          <span>{s.type}</span>
        </div>
      ))}
    </div>
  );
};
